// extracted by mini-css-extract-plugin
module.exports = {"eq":"Checkbox_eq__1jHt3","pl":"Checkbox_pl__x00LX","shuffle":"Checkbox_shuffle__158uJ","repeat":"Checkbox_repeat__1zPpi"};